import ct from "class-types.macro";
import React from "react";

interface ItemProps {
  children: React.ReactNode;
  sliderRight: boolean;
  classNames?: ClassTypes | string;
  colorVariant?: string;
  customInlineStyle?: React.CSSProperties;
}

export default function Item({
  children,
  sliderRight,
  classNames = ct("p-4", "text-center", "w-1/4", "md:w-2/12", "xxl:w-9-pc"),
  colorVariant,
  customInlineStyle,
}: ItemProps) {
  const colorStyles =
    colorVariant === "navy"
      ? ""
      : ct(
          "border-gray-200",
          "border-solid",
          "border-0",
          "border-r",
          "flex-col",
          "top-1/2",
          "transform",
          "origin-center",
          "scale-100"
        );

  return (
    <li
      className={`${ct(
        "group",
        "flex",
        "justify-center",
        "flex-shrink-0",
        "list-none",
        "relative",
        "scroll-snap-align-start",
        sliderRight ? ct("last:border-r-0") : "",
        colorStyles
      )} ${classNames}`}
      data-testid="main-slider-item"
      style={customInlineStyle}
    >
      {children}
    </li>
  );
}
